<div class="overview-root">
  <div class="overview-sidebar">
    <h4 class="overview-sidebar-title">{{ translate('documents.sidebar_types') }}</h4>
    <div>
      <span *ngFor="let stat of documentStats"
            (click)="onSidebarTypeClick(stat.type)"
            class="overview-type-chip"
            [class.selected]="selectedType === stat.type"
            [style.background]="chartColors[documentStats.indexOf(stat) % chartColors.length]">
        {{ translateType(stat.type) }}
      </span>
      <span *ngIf="selectedType" (click)="resetTypeFilter()" class="overview-type-chip clear">{{ translate('documents.clear_filter') }}</span>
    </div>
  </div>
  <div class="overview-main">
    <h2 class="overview-title">
      <mat-icon class="overview-icon">pie_chart</mat-icon>
      {{ translate('documents.types_distribution') }}
    </h2>
    <div class="overview-chart" *ngIf="!isLoading; else loading">
      <div echarts [options]="chartOptions" (chartInit)="onChartInit($event)"
        (chartClick)="onChartClick($event)" class="donut-chart xlarge"></div>
    </div>
    <ng-template #loading>
      <div class="overview-loading">
        <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
        <span>{{ translate('documents.loading') }}</span>
      </div>
    </ng-template>
    <div *ngIf="errorMessage" class="overview-error">
      <mat-icon>error</mat-icon> {{ errorMessage }}
    </div>
  </div>
</div>
